module.exports = __webpack_public_path__ + "img/nobori.3f5d0c53.png";